import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { easeOutExpo } from "@/lib/motion";

const WHATSAPP_URL =
  "https://wa.me/64220998181?text=Hey+Nathan,+I'm+interested+in+HANCOCK+coaching";

export const ApplyPage = () => {
  return (
    <div
      style={{ backgroundColor: "#050505", minHeight: "100vh", width: "100vw", position: "fixed", top: 0, left: 0, overflowY: "auto", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", padding: "5rem 1.5rem" }}
    >
      {/* Back link */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.4, ease: easeOutExpo }}
        style={{ position: "fixed", top: "1.5rem", left: "1.5rem" }}
      >
        <Link
          to="/"
          className="text-xs uppercase tracking-[0.2em] text-white/30 hover:text-white/60 transition-colors duration-300"
        >
          ← Back
        </Link>
      </motion.div>

      {/* Content — no card, just centered on black */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, ease: easeOutExpo, delay: 0.1 }}
        style={{ maxWidth: "480px", width: "100%", textAlign: "center", willChange: "transform, opacity" }}
      >
        {/* Logo */}
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.4, ease: easeOutExpo, delay: 0.2 }}
          className="mb-10"
        >
          <span
            className="font-syne font-bold tracking-tight text-white"
            style={{ fontSize: "1.1rem", letterSpacing: "0.05em" }}
          >
            HANCOCK.
          </span>
        </motion.div>

        {/* Heading */}
        <motion.h1
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, ease: easeOutExpo, delay: 0.25 }}
          className="font-syne font-bold tracking-tight text-3xl md:text-4xl text-white leading-tight mb-6"
        >
          Ready to start?
        </motion.h1>

        {/* Body */}
        <motion.p
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, ease: easeOutExpo, delay: 0.35 }}
          className="text-white/50 text-base md:text-lg leading-relaxed mb-4"
          style={{ fontFamily: "inherit", fontWeight: 300 }}
        >
          I work with a limited roster so every client gets genuine
          attention.
        </motion.p>

        <motion.p
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, ease: easeOutExpo, delay: 0.4 }}
          className="text-white/50 text-base md:text-lg leading-relaxed mb-12"
          style={{ fontFamily: "inherit", fontWeight: 300 }}
        >
          To apply, send me a message on WhatsApp and I'll get back to you
          within 24 hours.
        </motion.p>

        {/* WhatsApp Button */}
        <motion.a
          href={WHATSAPP_URL}
          target="_blank"
          rel="noopener noreferrer"
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, ease: easeOutExpo, delay: 0.5 }}
          whileHover={{ scale: 1.02 }}
          whileTap={{ scale: 0.98 }}
          className="inline-flex items-center justify-center gap-3 bg-white text-black font-syne font-bold text-sm uppercase tracking-[0.15em] px-10 py-5 rounded-full hover:bg-white/90 transition-colors duration-300 w-full"
          style={{ willChange: "transform" }}
        >
          Message on WhatsApp →
        </motion.a>

        {/* Sub note */}
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.4, ease: easeOutExpo, delay: 0.6 }}
          className="mt-8 text-xs uppercase tracking-[0.2em] text-white/20"
        >
          Typically replies within 24 hours
        </motion.p>
      </motion.div>
    </div>
  );
};

export default ApplyPage;
